<template>
    <div>
        <modal-success :title=titles.configureTypePackSuccessTitle @messageFromModal="closeModal"
                       id="configuration-typePack"/>
        <modal-error :title="titles.deleteTypePackErrorTitle" id="error-delete-typePack"/>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mt-0">{{titles.typePackListExpression}}</h4>
                        <b-row class="mb-2">
                            <TablePerPageSelect :perPage="perPage" :showPerPageSelect="false" @method="setPerPage"/>
                            <TableAddButton :nameButton=titles.typePackAddExpression :params="{maxId:maxId}"
                                            :showAddButton="showAddButton"
                                            pathName="addTypePack"/>
                        </b-row>
                        <b-table-simple>
                            <b-thead>
                                <b-th>Nom du type pack</b-th>
                                <b-th>Statut</b-th>
                                <b-th>
                                    Actions
                                    <a @click="configure" type="button" v-if="showConfigureButton">
                                        <i class="fas table-action-1 fa-save"/>
                                    </a>
                                </b-th>
                            </b-thead>
                            <b-tr v-if="inProgess">
                                <b-td colspan="3">
                                    <div>
                                        <Loading/>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr class="emptyData" v-if="!inProgess&!hasValue">
                                <b-td colspan="3">
                                    {{titles.emptyData}}
                                </b-td>
                            </b-tr>
                            <draggable :class="{[`cursor-grabbing`]: dragging == true}" @change="dragChanged"
                                       @end="dragging = false"
                                       @start="dragging = true" group="items" handle=".handle"
                                       tag="tbody" v-model="items">
                                <b-tr :key="element.id" class="handle" v-for="element in items">
                                    <b-td>
                                        {{element.label}}
                                    </b-td>
                                    <b-td>
                                        <i
                                                class="fas fa-check font-20 text-success"
                                                v-if="element.enabled"
                                        ></i>
                                        <i
                                                class="fas fa-times font-20 text-danger"
                                                v-if="!element.enabled"
                                        ></i>
                                    </b-td>
                                    <b-td>
                                        <TableEditInfoElement
                                                :params="{ typePackId: element.id, typePackItem: element, isEditable: isEditable }"
                                                name='UpdateTypePack'/>
                                        <TableDeleteElement :id="element.id" @method="deleteTypePack"/>
                                    </b-td>
                                </b-tr>
                            </draggable>
                        </b-table-simple>
                        <TablePagination :currentPage="currentPage" :perPage="perPage" :rows="rows"
                                         :showPagination="false"
                                         @method="setCurrentPage"/>
                    </div>
                    <!--end card-body-->
                </div>
                <!--end card-->
            </div>
            <!--end col-->
        </div>
    </div>
</template>

<script>
    import {filterMixin} from '@/utils/filterMixin';
    import {debounce} from 'vue-debounce';
    import {getAllTypePacks} from '@/components/shared/services/typePack.service';
    import {typePack} from '@/components/shared/models/typePack';
    import TablePerPageSelect from '@/components/common/TablePerPageSelect';
    import TablePagination from '@/components/common/TablePagination';
    import TableAddButton from '@/components/common/TableAddButton';
    import TableDeleteElement from '@/components/common/TableDeleteElement';
    import TableEditInfoElement from '@/components/common/TableEditInfoElement';
    import {titles} from '../../../utils/general/titles.js';
    import draggable from 'vuedraggable';
    import {
        updateAllTypePack,
        updateTypePack
    } from '../../shared/services/typePack.service';
    import router from '../../../router';
    import ModalError from '../../common/modal-error';
    import ModalSuccess from '../../common/modal-success';
    import Loading from '../../common/Loading';

    export default {
        name: 'Table',
        components: {
            Loading,
            TablePerPageSelect,
            TablePagination,
            TableAddButton,
            TableDeleteElement,
            TableEditInfoElement,
            draggable,
            ModalError,
            ModalSuccess
        },
        created() {
            this.$cookies.remove('typePackItems');
            this.$cookies.remove('typePackItem');
            this.$cookies.remove('typePackItemIsEditable');
            this.orderQueryGenerator('packOrder', false);
        },
        props: {
            okPressed: {
                type: Boolean,
                required: false
            },
            cancelPressed: {
                type: Boolean,
                required: false
            },
            okPressedUpdate: {
                type: Boolean,
                required: false
            },
            showAddButton: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                titles,
                dragging: false,
                typePackId: null,
                value: '',
                selected: null,
                filterList: [],
                filterQuery: '',
                expires: 0,
                txtInput: '',
                sort: '',
                perPage: 10,
                currentPage: 1,
                showFilter: false,
                rows: null,
                sortType: '',
                fields: [
                    {key: 'label', label: 'Nom du type pack', sortable: true},
                    {key: 'enabled', label: 'Statut', sortable: false},
                    {key: 'Actions', sortable: false}
                ],
                items: [],
                isEditable: true,
                params: Object,
                maxId: 0,
                showConfigureButton: false,
                inProgess: true,
                hasValue: null,
                forDelete: null,
                to: null
            };
        },
        mixins: [filterMixin],
        methods: {
            openDetailsModal(actualTypePack) {
                this.$emit('getTypePack', actualTypePack);
                this.$bvModal.show('typePack-detail');
            },
            deleteTypePack(id) {
                this.$bvModal.show('delete-typePack');
                this.forDelete = true;
                this.typePackId = id;
            },
            sortingChanged(ctx) {
                this.orderQueryGenerator(ctx.sortBy, ctx.sortDesc);
                this.fetchTypePacks();
            },
            debouncedFetchTypePacks: debounce(function (column, val, type, direction) {
                this.fetchTypePacks(column, val, type, direction);
            }, 300),
            changeValShowFilter(val) {
                this.showFilter = val;
            },
            setCurrentPage(val) {
                this.currentPage = val;
            },
            setPerPage(val) {
                this.perPage = val;
            },
            async fetchTypePacks(column, val, type) {
                this.inProgess = true;
                this.items = [];
                if (column) {
                    this.filterList = this.filterQueryGenerator(
                        this.filterList,
                        column,
                        val,
                        type
                    );
                }
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'deleted',
                    '0',
                    null
                );
                getAllTypePacks(
                    this.filterQuery, this.sort
                ).then(response => {
                    this.items = response.data['hydra:member'];
                    this.items = this.items.map(
                        function (item) {
                            return typePack(item);
                        }
                    );
                    this.hasValue = false;
                    if (this.items.length > 0) {
                        this.maxId = this.items.reduce(
                            (max, item) => (item.packOrder > max ? item.packOrder : max),
                            this.items[0].packOrder
                        );
                        this.hasValue = true;
                    }
                    this.$cookies.set('typePackItems', JSON.stringify(this.items));
                    this.rows = response.data['hydra:totalItems'];
                    this.inProgess = false;
                });
            },
            dragChanged(eventData) {
                if (eventData.moved && this.dragging == false) {
                    this.items = this.items.splice(eventData.moved.newIndex, 0, this.items.splice(eventData.moved.oldIndex, 1)[0]);
                }
                this.showConfigureButton = true;
            },
            configure() {
                this.$bvModal.show('order-typePack');
                this.forDelete = false;
                this.showConfigureButton = false;
            },
            closeModal() {
                if (this.to == null) {
                    this.$router.go();
                } else {
                    if (this.$route.name != this.to.name) {
                        this.$router.push({name: this.to.name, params: this.to.params});
                    }
                }
            }
        },
        mounted() {
            this.fetchTypePacks();
        },
        watch: {
            okPressed() {
                if (this.okPressed) {
                    if (this.forDelete == true) {
                        const item = this.items.find(itemInfo => itemInfo.id == this.typePackId);
                        if (item.isActive == true) {
                            this.$emit('deleted', false);
                            this.$bvModal.show('error-delete-typePack');
                        } else {
                            item.enabled = false;
                            item.isActive = false;
                            item.deleted = true;
                            updateTypePack(this.typePackId, item).then(
                                response => {
                                    this.fetchTypePacks();
                                    this.$emit('deleted', false);
                                    this.$bvModal.show('success-delete-typePack');
                                    return response;
                                },
                                error => {
                                    this.showError(error);
                                }
                            );
                        }
                    } else {
                        const data = [];
                        this.items.map(function (value, key) {
                            value.packOrder = key;
                            data.push(value);
                        });
                        this.items = data;
                        updateAllTypePack(this.items).then(
                            response => {
                                this.$emit('deleted', false);
                                this.$bvModal.show('configuration-typePack');
                                return response;
                            },
                            error => {
                                this.showError(error);
                            }
                        );
                    }
                }
            },
            cancelPressed() {
                if (this.cancelPressed) {
                    this.closeModal();
                }
            },
            currentPage: {
                handler() {
                    this.fetchTypePacks();
                }
            },
            perPage: {
                handler() {
                    this.fetchTypePacks();
                }
            }
        },
        beforeMount() {
            router.beforeEach((to, from, next) => {
                if (this.showConfigureButton) {
                    this.to = to;
                    this.configure();
                    next(false);
                } else {
                    next();
                }
            });
        }
    };
</script>

<style type="scss">
    @import '../../../assets/style/css/appStyle.css';
    @import '../../../assets/style/css/share/table.css';
</style>
